export { default } from './form-label'
export type { TProps as FormLabelProps } from './form-label'
